import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
`;

export const CustomerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
